import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useNavigationLogger } from './lib/navigationLogger';
import { useCopyLogsHotkey } from './lib/hotkeyCopyLogs';
import { TesterModeBanner } from './components/TesterModeBanner';
import { UpdateBanner } from './components/UpdateBanner';
import { AppShell } from './components/layout/AppShell';
import { TimelinePage } from './pages/timeline/TimelinePage';
import { ProjectDetailPage } from './pages/projects/ProjectDetailPage';
import { ProjectImportWizardPage } from './pages/projects/ProjectImportWizardPage';
import { WerkzeugePage } from './pages/WerkzeugePage';
import { HelpCenterPage } from './pages/HelpCenterPage';
import { SettingsPage } from './pages/SettingsPage';
import { BenutzerverwaltungPage } from './pages/BenutzerverwaltungPage';
import { TopBarChipPage } from './pages/TopBarChipPage';

function AppContent() {
  useNavigationLogger();
  useCopyLogsHotkey();
  return (
    <>
      <UpdateBanner />
      <TesterModeBanner />
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/timeline" replace />} />
          <Route path="timeline" element={<TimelinePage />} />
          {/* „Projekte"-Liste lebt jetzt auf der Programm-HQ-Seite (/timeline). */}
          <Route path="projects" element={<Navigate to="/timeline" replace />} />
          <Route path="projects/import" element={<ProjectImportWizardPage />} />
          <Route path="projects/:id" element={<ProjectDetailPage />} />
          <Route path="projects/:id/:phase" element={<ProjectDetailPage />} />
          <Route path="benutzerverwaltung" element={<BenutzerverwaltungPage />} />
          <Route path="topbar-chips" element={<TopBarChipPage />} />
          <Route path="werkzeuge" element={<WerkzeugePage />} />
          <Route path="help" element={<HelpCenterPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
